import * as v from "valibot";

import { rpcContract } from "../rpc";

export const saveUserThemeResultSchema = v.object({
  success: v.boolean(),
  message: v.optional(v.string()),
});

export type SaveUserThemesResult = v.InferOutput<typeof saveUserThemeResultSchema>;

export const saveUserThemesRpcContract = rpcContract({
  paramsSchema: v.object({
    categoryIds: v.array(v.string()),
  }),
  resultSchema: saveUserThemeResultSchema,
  name: "save-user-themes",
});

export type SaveUserThemesParams = v.InferOutput<(typeof saveUserThemesRpcContract)["paramsSchema"]>;
